import { bindActionCreators } from '@reduxjs/toolkit';
import classNames from 'classnames';
import jwt_decode from 'jwt-decode';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Avatar, Dropdown, DropdownButton } from 'vio-components';
import { getAuth0VaporCookie } from 'vio-libs';

import { requestRemoveServerSideCookie } from '../redux';
import { useAppDispatch } from '../redux/hooks';

import { Navbar } from '.';

interface IFrameworkHeaderProps {
	children?: any;
	className?: string;
}

const Logo = (props: any) => {
	return (<div id='vio-logo' className={ classNames('h-100', props.className) } { ...props } />);
};

const SubHeader = (props: any) => {
	return (<div id='vio-sub-header' className={ props.className } { ...props }>
		{ props.children }
	</div>);
};

const FrameworkHeader: React.FC<IFrameworkHeaderProps> = ({ ...props }) => {
	const dispatch = useAppDispatch();

	// REDUX ACTIONS
	const requestRemoveServerSideCookieDispatch = bindActionCreators(requestRemoveServerSideCookie, dispatch);
	// VARIABLES
	const auth0Authentication = getAuth0VaporCookie();
	const { idToken } = auth0Authentication;
	const userDetails: Record<string, any> = jwt_decode(idToken);
	const { email, picture } = userDetails;

	const logout = () => {
		requestRemoveServerSideCookieDispatch();
	};

	const renderUserDetails = (): JSX.Element => {
		const { t } = useTranslation();

		return (
			<div className='user-details'>
				<Avatar
					src={ picture }
					defaultSrc={ require('../../public/default-avatar.png') } />
				<DropdownButton
					id='user-details-dropdown'
					align='end'
					title={ email }
					variant='outline-link'>
					<Dropdown.Item onClick={ logout }>{ t('LOGOUT') }</Dropdown.Item>
				</DropdownButton>
			</div>
		);
	};

	return (
		<header id='vio-header' className={ props.className }>
			<div className='left'>
				<Logo />
			</div>

			<div className='right'>
				{ props.children }
				{ renderUserDetails() }
			</div>
		</header>
	);
};

const Header: React.FC = () => {
	return (
		<>
			<FrameworkHeader>
				<Navbar />
			</FrameworkHeader>

			<SubHeader />
		</>
	);
};

export default Header;
